module.exports = __webpack_public_path__ + "img/zhuzhai.ae1ddb62.png";